import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Auth } from '@ax/auth';
import NoteTypePolicy from './typePolicies/note';
import { PROJECT_ENVIRONMENT } from '@ax/env';

const httpLink = createHttpLink({
  uri: PROJECT_ENVIRONMENT.API['graphql-api'].base_url,
});

const authLink = setContext((_, { headers }) => {
  const authToken = Auth.getAccessToken() ?? '';

  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Note: NoteTypePolicy,
    },
  }),
});

export { client };
